/**
 * Custom checkout — mobile collapsible "Twoje zamówienie" na górze strony.
 *
 * Markup (form-checkout.php):
 *   <div class="hn-co__mobile-summary" data-open="false">
 *     <button data-hn-co-summary-toggle aria-expanded="false">…icon + total + chevron…</button>
 *     <div class="hn-co__mobile-summary-body" data-hn-co-mobile-body hidden>
 *       <?php order-review partial ?>
 *     </div>
 *   </div>
 *
 * Klik na toggle: rozwija/zwija body (przez `hidden` attribute + aria-expanded
 * + `data-open` na wrapperze — CSS używa `[data-open="true"]` żeby obrócić chevron).
 */
export function initCheckoutMobileSummary() {
    document.addEventListener('click', (e) => {
        const btn = e.target.closest && e.target.closest('[data-hn-co-summary-toggle]');
        if (!btn) return;
        e.preventDefault();

        const wrap = btn.closest('.hn-co__mobile-summary');
        const body = wrap && wrap.querySelector('[data-hn-co-mobile-body]');
        if (!body) return;

        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        const next = !isOpen;

        btn.setAttribute('aria-expanded', next ? 'true' : 'false');
        if (wrap) wrap.setAttribute('data-open', next ? 'true' : 'false');
        if (next) {
            body.removeAttribute('hidden');
        } else {
            body.setAttribute('hidden', '');
        }

        /* Label „Pokaż" ⇄ „Ukryj" — bez tego przycisk kłamie po rozwinięciu. */
        const label = btn.querySelector('.hn-co__mobile-summary-text');
        const nextLabel = label && label.getAttribute(next ? 'data-label-hide' : 'data-label-show');
        if (nextLabel) label.textContent = nextLabel;
    });
}
